var countries = require('./resources/countries-min');

var industries = require('./resources/industries');

var createTopicHash = function createTopicHash(topicName) {
  if (!topicName) {
    throw new Error('Cannot create hash from empty name!');
  }

  return topicName.toLowerCase().replace(/\s+/g, '').replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, '');
};

var ageGroups = [{
  name: '0-17',
  from: 0,
  to: 17
}, {
  name: '18-25',
  from: 18,
  to: 25
}, {
  name: '26-35',
  from: 26,
  to: 35
}, {
  name: '36-55',
  from: 36,
  to: 55
}, {
  name: '56+',
  from: 56,
  to: 199
}];

var getAgeGroupName = function getAgeGroupName(age) {
  var ageGroupName = null;

  if (Number.isInteger(age)) {
    for (var i = 0; i < ageGroups.length; i++) {
      var ageGroup = ageGroups[i];

      if (Math.max(ageGroup.from, Math.min(age, ageGroup.to)) === age) {
        ageGroupName = ageGroup.name;
        break;
      }
    }
  }

  return ageGroupName;
};

var getCountryByCode = function getCountryByCode(countryCode) {
  var country = countries.find(function (c) {
    return c.code === countryCode;
  });
  return country;
};

var getIndustries = function getIndustries() {
  return industries;
};

module.exports = {
  createTopicHash: createTopicHash,
  getAgeGroupName: getAgeGroupName,
  getCountryByCode: getCountryByCode,
  getIndustries: getIndustries
};